export default __webpack_public_path__ + "static/media/Girdle of the Membranous.53670a1a.jpg";